$(document).ready(function (): any {
    $("body").on("submit"
        , "main form:not([data-dont-use-ajax-submit='true']):not([data-act-as-grid-filter='true'])"
        + ",div.bootbox form:not([data-dont-use-ajax-submit='true']):not([data-act-as-grid-filter='true'])"
        , function (e: Event): any {
            let $form: JQuery = $(this);

            e.preventDefault();

            if (typeof ($form.valid) !== "function") {
                console.error("JQuery validation plugin not found!");
            }

            if (!($form.valid) || $form.valid()) {
                let formData: FormData = new FormData(this);
                let getAsBlob: boolean = $form.data("get-as-blob");

                $.ajax(<JQueryAjaxSettings>{
                    url: $form.attr("action"),
                    method: $form.attr("method"),
                    data: formData,
                    processData: false,
                    contentType: false,
                    headers: {
                        "X-Should-Return-Partial": "true"
                    },
                    success: function (data: any, textStatus: string, jqXHR: JQueryXHR): void {
                        let $modal: any = $form.closest("div.bootbox");


                        let isInvalidModel: boolean = jqXHR.getResponseHeader("X-modelstate-invalid") === "true";
                        let isKeepPopup: boolean = jqXHR.getResponseHeader("X-keep-popup") === "true";
                        if ((!isInvalidModel && !isKeepPopup) && $modal.length > 0) { // hide popup if saved successfully
                            let bootboxCallbackOnSuccess: string = $modal.data("callback-on-success");

                            $modal.modal("hide");

                            if (typeof bootboxCallbackOnSuccess !== "undefined"
                                && bootboxCallbackOnSuccess !== null
                                && bootboxCallbackOnSuccess !== "") {
                                //let f: any = Nrl.Common.Helpers.EvalHelper.GetFunction(bootboxCallbackOnSuccess);
                                //f();
                            }

                        } else { // error or not popup
                            $form.removeData("validator");
                            $form.removeData("unobtrusiveValidation");

                            let $data: JQuery = $(data);
                            $form.replaceWith($data);

                            if ($.validator) {
                                $.validator.unobtrusive.parse($data);
                            }

                            //Nrl.Common.Validation.ValidateForm($data);
                        }
                    },
                    error: function (jqXHR: JQueryXHR, textStatus: string, errorThrown: string): void {
                        //debugger;
                    },
                    dataType: getAsBlob ? "binary" : "html"
                });
            }
        }
    );

    // $("body").on("submit"
    //     , "div#app-content form[data-act-as-grid-filter='true']"
    //     + ", div.bootbox form[data-act-as-grid-filter='true']"
    //     , function (e: Event): any {
    //         let $form: JQuery = $(this);

    //         e.preventDefault();

    //         if (typeof ($form.valid) !== "function") {
    //             console.error("JQuery validation plugin not found!");
    //         }

    //         if (!($form.valid) || $form.valid()) {
    //             let gridList: JQuery = $("div.dx-widget[data-additional-filter-form-jquery-selector]");
    //             gridList.each(function (index: number, elem: Element): any {
    //                 let $grid: JQuery = $(elem);
    //                 let formSelector: string = $grid.data("additional-filter-form-jquery-selector");

    //                 if (formSelector !== null && formSelector !== "") {
    //                     let $targetForm: JQuery = $(formSelector);
    //                     if ($targetForm.length > 0) {
    //                         if ($form[0] === $targetForm[0]) {

    //                             if ($grid.hasClass("dx-treelist")) {
    //                                 // this grid should be refreshed by this form
    //                                 (<any>$grid.dxTreeList("instance")).filter(
    //                                     "{do-not-parse}",
    //                                     "{additionalfilter}",
    //                                     $form.find("*:not(.sys-exclude-from-serialization)").serialize()
    //                                 );

    //                                 //force tree list GET method
    //                                 if ($form.data("refresh-grid-filter-on-submit") === true) {
    //                                     (<any>$grid.dxTreeList("instance")).refresh();
    //                                 }
    //                             } else {
    //                                 // this grid should be refreshed by this form
    //                                 (<any>$grid.dxDataGrid("instance")).filter(
    //                                     "{do-not-parse}",
    //                                     "{additionalfilter}",
    //                                     $form.find("*:not(.sys-exclude-from-serialization)").serialize()
    //                                 );

    //                                 //force grid GET method (Devexpress won't submit if grid filter doesn't change)
    //                                 if ($form.data("refresh-grid-filter-on-submit") === true) {
    //                                     (<any>$grid.dxDataGrid("instance")).refresh();
    //                                 }
    //                             }
    //                         }
    //                     }
    //                 }
    //             });
    //         }
    //     }
    // );

    // $("body").on("reset"
    //     , "div#app-content form[data-act-as-grid-filter='true']"
    //     + ", div.bootbox form[data-act-as-grid-filter='true']"
    //     , function (e: Event): any {
    //         let $form: JQuery = $(this);
    //         let gridList: JQuery = $("div.dx-widget[data-additional-filter-form-jquery-selector]");
    //         gridList.each(function (index: number, elem: Element): any {
    //             let $grid: JQuery = $(elem);
    //             let formSelector: string = $grid.data("additional-filter-form-jquery-selector");
    //             if (formSelector !== null && formSelector !== "") {
    //                 let $targetForm: JQuery = $(formSelector);
    //                 if ($targetForm.length > 0) {
    //                     if ($form[0] === $targetForm[0]) {
    //                         if ($grid.hasClass("dx-treelist")) { //treeList clear filters
    //                             (<any>$grid.dxTreeList("instance")).clearFilter();
    //                         } else { //dataGrid clear filters
    //                             (<any>$grid.dxDataGrid("instance")).clearFilter();
    //                         }
    //                     }
    //                 }
    //             }
    //         });
    //     }
    // );
});

function DisableDoubleSubmit(event: Event, sender: any): void {
    const $form: JQuery = $(sender);

    let isSubmitted: boolean = $form.data("isSubmitted") === "true";

    if (isSubmitted) {
        event.preventDefault();
    } else {
        $form.data("isSubmitted", "true");
    }
}